import cn from 'classnames';
import type { MenuProps as MaterialMenuProps, MenuClassKey as MaterialMenuClassKey } from '@mui/material';
import { StyledMaterialMenu } from './styles';

export type DropdownMenuProps = {
  className?: string;
} & MaterialMenuProps;

const DropdownMenu = ({ children, className, classes = {}, ...otherProps }: DropdownMenuProps) => {
  const compoundClasses: Partial<Record<MaterialMenuClassKey, string>> = {
    list: cn(classes.list, className),
    paper: cn(classes.paper),
  };

  return (
    <StyledMaterialMenu classes={compoundClasses} {...otherProps}>
      {children}
    </StyledMaterialMenu>
  );
};

export default DropdownMenu;
